// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3NjqA","title":"Info_title__2avy1","selects":"Info_selects__YtXf7","requiredAsterisk":"Info_requiredAsterisk__3Y9sY"};